import React, {Fragment} from "react"

import { withStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import TextField from '@material-ui/core/TextField'
import { I18n } from 'react-redux-i18n'

const styles = theme => ({
  container: {
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit,
  },
  errorLabelContainer:{
    margin: theme.spacing.unit,
  },
  errorLabel:{
    color: theme.palette.error.main,
  },
  input:{
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: 'calc(100% - ' + theme.spacing.unit*2 + 'px)',
  },
});

class Subjects extends React.Component {
  render() {
    let error = false
    let errorMessage = ''

    if(this.props.newAppointment.error != null ){
      if(this.props.newAppointment.error.errors.date != null){
        error = true
        errorMessage = this.props.newAppointment.error.errors.date[0]
      }
    }

    return (
      <Fragment>
        <FromDate
          classes={this.props.classes}
          error={error}
          errorMessage={errorMessage}
          newAppointment={this.props.newAppointment}
          handleFromDateChange={this.props.handleFromDateChange}
          handleFromTimeChange={this.props.handleFromTimeChange} />
        <ToDate
          classes={this.props.classes}
          error={error}
          errorMessage={errorMessage}
          newAppointment={this.props.newAppointment}
          handleToDateChange={this.props.handleToDateChange}
          handleToTimeChange={this.props.handleToTimeChange} />
      </Fragment>
    )
  }
}

function FromDate(props){
  const { classes } = props

  return (
    <Grid container className={classes.container}>
      <Grid item xs={12} className={classes.errorLabelContainer}>
        <label className={classes.errorLabel}>
          {props.error ?
            (
              props.errorMessage
            ) : (
              null
            )

          }
        </label>
      </Grid>
      <Grid item xs={7}>
        <TextField
          error={props.error}
          onChange={props.handleFromDateChange}
          value={props.newAppointment.fromDate.format('YYYY-MM-DD')}
           label={I18n.t('editAppointment.from_date')}
           type="date"
           className={classes.input}
           InputLabelProps={{
             shrink: true,
           }}
         />
      </Grid>
      <Grid item xs={5}>
       <TextField
         error={props.error}
         onChange={props.handleFromTimeChange}
         value={props.newAppointment.fromDate.format('HH:mm')}
          label={I18n.t('editAppointment.from_time')}
          type="time"
          className={classes.input}
          InputLabelProps={{
            shrink: true,
          }}
          inputProps={{
            step: 300, // 5 min
          }}
        />
      </Grid>
    </Grid>
  )
}

function ToDate(props){
  const { classes } = props

  return (
    <Grid container className={classes.container}>
      <Grid item xs={12} className={classes.errorLabelContainer}>
        <label className={classes.errorLabel}>
          {props.error ?
            (
              props.errorMessage
            ) : (
              null
            )

          }
        </label>
      </Grid>
      <Grid item xs={7}>
        <TextField
          error={props.error}
          onChange={props.handleToDateChange}
          value={props.newAppointment.toDate.format('YYYY-MM-DD')}
         label={I18n.t('editAppointment.to_date')}
         type="date"
         className={classes.input}
         InputLabelProps={{
           shrink: true,
         }}
        />
      </Grid>
      <Grid item xs={5}>
        <TextField
          error={props.error}
          onChange={props.handleToTimeChange}
          value={props.newAppointment.toDate.format('HH:mm')}
          label={I18n.t('editAppointment.to_time')}
          type="time"
          className={classes.input}
          InputLabelProps={{
            shrink: true,
          }}
          inputProps={{
            step: 300, // 5 min
          }}
        />
      </Grid>
    </Grid>
  )
}

export default withStyles(styles)(Subjects)



// WEBPACK FOOTER //
// ./src/js/components/pages/newAppointment/Dates.js